import React from 'react';
import '../../styles/GSIDA.css';
import cogsida from '../../assets/cigsida.png'; // GSIDA Logo


export default function GSIDAPresentation() {
  return (
    <div className="gsida-presentation-page">
      <div className="gsida-header-banner">
         <div className="banner-overlay">
            <h1>Présentation du Congrès GSIDA</h1>
            <p>Congrès International sur la Gouvernance Sécuritaire et l'Intelligence Digitale en Afrique</p>
         </div>
      </div>

      <div className="gsida-content-container">
        
        <section className="gsida-intro-card">

          
        
        

          <div className="section-header-v2">
            <span className="accent-line"></span>
            <h3>Un Événement International de Référence</h3>
          </div>
            <img src={cogsida} alt="GSIDA Logo" className="central-branding-logo" />
          <p>
            Le Congrès International <strong>GSIDA</strong> (Global Security & Institutional Digital Architecture) est l'un des rendez-vous stratégiques majeurs du continent africain. Il rassemble chaque année des décideurs publics, des experts internationaux, des universitaires et des leaders technologiques pour débattre des défis de la sécurité à l'ère du numérique.
          </p>
          <p>
            Depuis sa création, GSIDA s'est imposé comme une plateforme de dialogue unique entre le Nord et le Sud, favorisant le transfert de technologies et la co-construction de modèles de gouvernance innovants, éthiques et souverains.
          </p>
        </section>

        <section className="gsida-objectives">
          
          <div className="section-header-v2">
            <span className="accent-line"></span>
            <h3>LES OBJECTIFS DU CONGRES</h3>
          </div>

     


          <div className="obj-grid">
            <div className="obj-card">
              <span className="num">01</span>
              <h4>Analyse Stratégique</h4>
              <p>Décrypter les nouvelles menaces hybrides et les vulnérabilités institutionnelles.</p>
            </div>
            <div className="obj-card">
              <span className="num">02</span>
              <h4>Innovation</h4>
              <p>Promouvoir l'intégration de l'Intelligence Artificielle et du Big Data dans les systèmes de défense.</p>
            </div>
            <div className="obj-card">
              <span className="num">03</span>
              <h4>Coopération</h4>
              <p>Bâtir des partenariats durables entre les institutions publiques et les acteurs privés de la tech.</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
